import { defineMessages } from '@jutro/locale';

export default defineMessages({
    ClaimDetails: {
        id: 'ml.claim.views.ml-claim-details.Claim details',
        defaultMessage: 'Claim details'
    },
    SubHeader: {
        id: 'ml.claim.views.ml-claim-details.Here are the details for claim x on policy y',
        defaultMessage: 'Here are the details for claim {claimNumber} on policy {policyNumber}'
    },
    RetrievingClaimDetails: {
        id: 'ml.claim.views.ml-claim-details.Retrieving claim details...',
        defaultMessage: 'Retrieving claim details...'
    },
    RentalReservation: {
        id: 'ml.claim.views.ml-claim-details-activities.We created a rental reservation with Enterprise Rent-A-Car',
        defaultMessage: 'We created a rental reservation with Enterprise Rent-A-Car. The reservation number is {resNumber} and the branch location is {rentBranchAddress} {phoneNumber}'
    },
    RentalCompleted: {
        id: 'ml.claim.views.ml-claim-details-activities.Rental completed',
        defaultMessage: 'Rental completed'
    },
    PaymentForCoverage: {
        id: 'ml.claim.views.ml-claim-details-activities.A payment for x for y has been issued',
        defaultMessage: 'A payment for {amount} for {coverage} has been issued'
    }
});
